import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FetchSecurityMaster } from "../../api/api";
import Cookies from "js-cookie";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const FundFeesForm = () => {
  const [fundList, setFundList] = useState<any>(null);
  const [rowData, setRowData] = useState<any>(null);
  const [selectFundId, setSelectFundId] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  const [formData, setFormData] = useState({
    fund: "",
    account: "",
    tradeCode: "",
    feeAmount: "",
    period: "Daily",
    beginDate: "",
    endDate: "",
    clientId: "",
  });

  useEffect(() => {
    FetchSecurityMaster(
      "TransactionCodesToAllocate",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setRowData(response);
    });

    FetchSecurityMaster(
      "Fund",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setFundList(response);
    });
  }, []);
  console.log(rowData);
  const handleFund = (e: any) => {
    setSelectFundId(e[0]);
  };

  const TradeCodeOptions: any[] = [];

  rowData &&
    rowData.map((e: any) => {
      return TradeCodeOptions.push({
        label: `${e.transactionCode}`,
        id: e.transactionCode,
      });
    });

  const typeHeadOptions: any[] = [];

  fundList &&
    fundList.map((e: any) => {
      return typeHeadOptions.push({
        label: `${e.fund} - ${e.fundName}`,
        description: e.fund,
        id: e.fundID,
      });
    });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log(formData);
    // Perform form submission logic here
  };

  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Fund Fee</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        <Tabs>
          <TabList>
            <Tab>Fund Fees</Tab>
            <Tab>Account Fees</Tab>
          </TabList>

          <TabPanel>
            <div className="container mt-4 p-4">
              <form onSubmit={handleSubmit}>
                <div className="row mb-2">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="fund" className="form-label">
                      Fund
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <Typeahead
                      id="basic-example"
                      onChange={handleFund}
                      options={typeHeadOptions}
                      placeholder="Choose Fund..."
                      selected={selectFundId ? [selectFundId] : []}
                    />
                  </div>
                </div>

                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="tradeCode" className="form-label">
                      TranCode
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <Typeahead
                      id="basic-example"
                      onChange={handleFund}
                      options={TradeCodeOptions}
                      placeholder="Choose Fund..."
                      selected={selectFundId ? [selectFundId] : []}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="feeAmount" className="form-label">
                      Fee Schedule ID
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="number"
                      className="form-control"
                      id="feeAmount"
                      name="feeAmount"
                      value={formData.feeAmount}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="feeAmount" className="form-label">
                      Fee Amount
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="number"
                      className="form-control"
                      id="feeAmount"
                      name="feeAmount"
                      value={formData.feeAmount}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="period" className="form-label">
                      Period
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <select
                      className="form-select text-small form-control"
                      id="period"
                      name="period"
                      value={formData.period}
                      onChange={handleChange}
                    >
                      <option value="Daily">Daily</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="beginDate" className="form-label">
                      Begin Date
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="date"
                      className="form-control"
                      id="beginDate"
                      name="beginDate"
                      value={formData.beginDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="endDate" className="form-label">
                      End Date
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 mt-4 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="endDate" className="form-label"></label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <button type="submit" className="btn btn-link px-1">
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary mx-3">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="container mt-4 p-4">
              <form onSubmit={handleSubmit}>
                <div className="row mb-2">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="fund" className="form-label">
                      Fund
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <Typeahead
                      id="basic-example"
                      onChange={handleFund}
                      options={typeHeadOptions}
                      placeholder="Choose Fund..."
                      selected={selectFundId ? [selectFundId] : []}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="tradeCode" className="form-label">
                      Participant ID
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <Typeahead
                      id="basic-example"
                      onChange={handleFund}
                      options={TradeCodeOptions}
                      placeholder="Choose Fund..."
                      selected={selectFundId ? [selectFundId] : []}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="tradeCode" className="form-label">
                      TranCode
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <Typeahead
                      id="basic-example"
                      onChange={handleFund}
                      options={TradeCodeOptions}
                      placeholder="Choose Fund..."
                      selected={selectFundId ? [selectFundId] : []}
                    />
                  </div>
                </div>

                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="feeAmount" className="form-label">
                      Fee Amount
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="number"
                      className="form-control"
                      id="feeAmount"
                      name="feeAmount"
                      value={formData.feeAmount}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="period" className="form-label">
                      Accrual Period
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <select
                      className="form-select text-small form-control"
                      id="period"
                      name="period"
                      value={formData.period}
                      onChange={handleChange}
                    >
                      <option value="Daily">Daily</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="beginDate" className="form-label">
                      Begin Date
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="date"
                      className="form-control"
                      id="beginDate"
                      name="beginDate"
                      value={formData.beginDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="endDate" className="form-label">
                      End Date
                    </label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-2 mt-4 row">
                  <div className="mb-2 col-md-2">
                    <label htmlFor="endDate" className="form-label"></label>
                  </div>
                  <div className="mb-2 col-md-4 error-placeholder">
                    <button type="submit" className="btn btn-link px-1">
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary mx-3">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export { FundFeesForm };
